import { useEffect } from 'react';
import { useToast  } from '@chakra-ui/react';
import { useQuery } from 'react-query';
import { getApplication } from '../../service';

type Props = {
  params:any;
};

function Application({ params }: Props) {
  const toast = useToast();

  if (params.token === undefined) {
    toast({
      title: '접근 오류',
      description: '접근 권한이 없습니다.',
      status: 'error',
      position: 'top',
    });
    window.location.href = '/';
  }

  const { isLoading, error, data } = useQuery('getPage', () => getApplication(params.first, params.token));

  useEffect(() => {
    if (error) {
      toast({
        title: '접근 오류',
        description: '접근 권한이 없습니다.',
        status: 'error',
        position: 'top',
      });
    }
  }, [error])


  return (
    <>
    {
      !isLoading && !error && data && (
        <>
          {data.title}
        </>
      )
    }
    </>
  );
}

Application.defaultProps = {
};

export default Application;
